import { createFileRoute } from "@tanstack/react-router";
import { ALL_ARTICLES } from "@/lib/article-index";

const TITLE = "Quick Expat Guides 2026: Short Summaries | LifeWestWay";
const DESC =
  "Short summaries of LifeWestWay's quick-read expat guides on visas, money, housing and work in six countries, with the main points of each guide.";

const QUICK = ALL_ARTICLES.filter((a) => a.words < 1800).sort((a, b) =>
  a.countryLabel.localeCompare(b.countryLabel) || a.title.localeCompare(b.title),
);

export const Route = createFileRoute("/quick-guides")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://lifewestway.com/quick-guides" }],
  }),
  component: QuickGuides,
});

function QuickGuides() {
  const countries = [...new Set(QUICK.map((a) => a.countryLabel))];
  return (
    <main className="mx-auto max-w-5xl px-4 py-12">
      <h1 className="text-3xl font-bold text-foreground md:text-4xl">Quick Expat Guides</h1>
      <p className="mt-3 max-w-2xl text-muted-foreground">
        Short on time? Each card sums up one quick-read guide and lists its main points. Open a card to read the
        full guide.
      </p>
      {countries.map((c) => (
        <section key={c} className="mt-10">
          <h2 className="text-2xl font-semibold text-primary">{c}</h2>
          <div className="mt-4 grid gap-4 md:grid-cols-2">
            {QUICK.filter((a) => a.countryLabel === c).map((a) => (
              <article key={a.href} className="rounded-xl border border-border bg-card p-5">
                <p className="text-xs uppercase tracking-wide text-muted-foreground">
                  {a.category} · {a.readMinutes} min read
                </p>
                <h3 className="mt-1 text-lg font-semibold text-foreground">
                  <a href={a.href} className="hover:text-primary">
                    {a.title.replace(/\.\.\.$/, "")}
                  </a>
                </h3>
                <p className="mt-2 text-sm text-muted-foreground">{a.description}</p>
                {a.keyPoints.length > 0 && (
                  <ul className="mt-3 list-disc space-y-1 pl-5 text-sm text-foreground/90">
                    {a.keyPoints.map((k) => (
                      <li key={k}>{k}</li>
                    ))}
                  </ul>
                )}
                <a href={a.href} className="mt-3 inline-block text-sm font-medium text-primary">
                  Read the full guide →
                </a>
              </article>
            ))}
          </div>
        </section>
      ))}
    </main>
  );
}
